<template>
    <flex-element>
        <div class="f-flex component__div f-h-1/1">
            <o-container
                v-bind="element(1)"
                class="f-flex tabs__section f-items-center"
                @element-updated="elementUpdated"
            >
                <template v-slot="{ elementUpdated, elementsNew}">
                    <tab-container
                        v-for="(element, index) in elementsNew"
                        :key="element.id"
                        class="f-block f-z-1 f-items-center f-flex-grow"
                        :class="{ [STATE_CLASSES.SELECTED]: isActiveIndex(index)}"
                        v-bind="element"
                        :index="index"
                        :pointer="index + 1"
                        is-dynamic-element
                        @element-updated="elementUpdated"
                        @click.native="onTabClick(index)"
                    >
                        <!-- eslint-disable-next-line vue/no-template-shadow -->
                        <template v-slot="{ elementUpdated, elementsNew }">
                            <div class="f-flex f-flex-wrap f-bg-transparent f-h-1/1">
                                <component
                                    :is="innerElement.elementType"
                                    v-for="(innerElement, innerIndex) in elementsNew"
                                    :key="innerElement.id"
                                    :pointer="innerIndex + 1"
                                    :index="innerIndex"
                                    v-bind="innerElement"
                                    @element-updated="elementUpdated"
                                />
                            </div>
                        </template>
                    </tab-container>
                </template>
            </o-container>
            <o-container
                ref="panes"
                class="f-flex"
                v-bind="element(2)"
                :display-name="`Tab Panes Container`"
                @element-updated="elementUpdated"
            >
                <template v-slot="{ elementUpdated, elementsNew }">
                    <tab-pane-container
                        v-for="(element, index) in elementsNew"
                        v-show="isActiveIndex(index)"
                        :key="element.id"
                        :index="index"
                        :pointer="index + 1"
                        v-bind="element"
                        @element-updated="elementUpdated"
                    >
                        <!-- eslint-disable-next-line vue/no-template-shadow -->
                        <template v-slot="{ elementUpdated, elementsNew }">
                            <div class="f-flex f-flex-wrap f-bg-transparent">
                                <component
                                    :is="innerElement.elementType"
                                    v-for="(innerElement, innerIndex) in elementsNew"
                                    :key="innerElement.id"
                                    :pointer="innerIndex + 1"
                                    :index="innerIndex"
                                    v-bind="innerElement"
                                    @element-updated="elementUpdated"
                                />
                            </div>
                        </template>
                    </tab-pane-container>
                </template>
            </o-container>
        </div>
    </flex-element>
</template>

<script>
import uniqid from 'uniqid';

import baseOrganism from '@/mixins/base-organism/base-organism-dumb';
import { STATE_CLASSES } from '@/data/constants/classes';

export default {
    name: 'dynamic-tabbed-nav',
    mixins: [baseOrganism],

    props: {
        displayName: {
            type: String,
            default: 'Dynamic Tabbed Nav',
        },
    },

    data() {
        return {
            cssDisplay: 'block',
            currentTabIndex: 0,
            itemId: uniqid(),
            STATE_CLASSES,
        };
    },

    methods: {
        onTabClick(clickedIndex) {
            this.currentTabIndex = clickedIndex;
        },

        isActiveIndex(index) {
            return index === this.currentTabIndex;
        },
    },
};
</script>
